import { useSelector } from "react-redux";
import "./Loader.css";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const Loader = () => {
  const [t] = useTranslation();
  const loaderState = useSelector((state) => state.loader.isLoading);

  useEffect(() => {
    console.log(loaderState);
  }, [loaderState]);

  return (
    <>
      {loaderState && (
        <div className="loader-containner">
          <div>{t("loading.text")}</div>
        </div>
      )}
    </>
  );
};

export default Loader;
